import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const setDefaultPaymentMethodReducer = createReducer<State, Actions>(initialState, {
  [actions.setDefaultPaymentMethod.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.setDefaultPaymentMethod.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.setDefaultPaymentMethod.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.setDefaultPaymentMethod.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default setDefaultPaymentMethodReducer;
